import config from '#/config';
import { useGetAccountDetails } from '#/hooks/useGetAccountDetails';

export const useGetAmendmentEmail = () => {
    const accountDetails = useGetAccountDetails();
    return accountDetails?.AmendmentsEmail || config.editBookingEmailAddress || 'agents@travviagroup.com ';
};
